<template>
    <v-app class="theme--welcome">
        <v-slide-x-transition mode="out-in">
            <router-view></router-view>
        </v-slide-x-transition>
    </v-app>
</template>

<script>
export default {
  created() {
  },
};
</script>
